import { mutationActions } from '../app-root';
import { MetadataBlockActions } from '@masala-lib/editorial/models/actions/metadata-block-actions';

export class ScriptEditorMetadataBlockActions extends MetadataBlockActions {
  get mutationActions() {
    return mutationActions;
  }
}
